export const reportConst = {
    auto_reg: 'auto_reg',
    new_institution: 'new_institution',
    call_back: 'call_back'
};